enum ScreenSize {
  Small = 0,
  Medium = 1,
  Large = 2,
}
export default ScreenSize;
